import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";

const initiatives = [
  {
    title:
      "Steel Secretary Shri Sandeep Poundrik Visits Moira Steel, Indore on 23 October 2025",
    link: "#",
    images: [
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/17-nov-2025-01.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/17-nov-2025-02.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/17-nov-2025-03.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/17-nov-2025-04.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/17-nov-2025-05.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/17-nov-2025-06.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/17-nov-2025-07.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/17-nov-2025-08.jpg",
    ],
  },
  {
    title:
      "Plant Visit and Brainstorming Session on Steel Sector Development, Delhi-UP on 14 November 2025",
    link: "#",
    images: [
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/18-nov-2025-01.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/18-nov-2025-02.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/18-nov-2025-03.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/18-nov-2025-04.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/18-nov-2025-05.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/18-nov-2025-06.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/18-nov-2025-07.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/18-nov-2025-08.jpg",
      "https://cloud.hoverbusinessservices.com/aiifa/media/recent-initiative/18-nov-2025-09.jpg",
    ],
  },
  {
    title:
      "Sustainable Quality Steelmaking Conference-23rd – 24th April 2026 in Jamshedpur, Jharkhand.",
    link: "#",
    images: [
      "https://res.cloudinary.com/dxvbzgdgw/image/upload/v1777441176/WhatsApp_Image_2026-04-28_at_17.41.37_wtmqk1.jpg",
    ],
  },
];

const Lightbox = ({ images, title, startIndex, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(startIndex);
  const [touchStartX, setTouchStartX] = useState(null);

  const navigate = useCallback(
    (dir) => {
      setCurrentIndex((prev) => (prev + dir + images.length) % images.length);
    },
    [images.length]
  );

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowLeft") navigate(-1);
      if (e.key === "ArrowRight") navigate(1);
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [navigate, onClose]);

  const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) navigate(diff > 0 ? 1 : -1);
    setTouchStartX(null);
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.9)",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: 16,
          right: 20,
          background: "none",
          border: "none",
          color: "#fff",
          fontSize: 32,
          cursor: "pointer",
          lineHeight: 1,
          zIndex: 10,
        }}
      >
        &times;
      </button>

      {/* Title & Counter */}
      <p
        style={{
          color: "rgba(255,255,255,0.7)",
          fontSize: 13,
          marginBottom: 12,
          userSelect: "none",
        }}
      >
        {title} &nbsp;·&nbsp; {currentIndex + 1} / {images.length}
      </p>

      {/* Image */}
      <img
        src={images[currentIndex]}
        alt={title}
        onClick={(e) => e.stopPropagation()}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        style={{
          maxHeight: "75vh",
          maxWidth: "90vw",
          objectFit: "contain",
          borderRadius: 6,
          display: "block",
          userSelect: "none",
          WebkitUserDrag: "none",
        }}
      />

      {/* Prev / Next */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 24,
          marginTop: 16,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            background: "rgba(255,255,255,0.15)",
            border: "none",
            color: "#fff",
            fontSize: 20,
            width: 44,
            height: 44,
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          &#8592;
        </button>

        {/* Dot indicators */}
        <div style={{ display: "flex", gap: 6 }}>
          {images.map((_, i) => (
            <span
              key={i}
              onClick={() => setCurrentIndex(i)}
              style={{
                width: i === currentIndex ? 20 : 8,
                height: 8,
                borderRadius: 4,
                background:
                  i === currentIndex
                    ? "#fff"
                    : "rgba(255,255,255,0.35)",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
            />
          ))}
        </div>

        <button
          onClick={() => navigate(1)}
          style={{
            background: "rgba(255,255,255,0.15)",
            border: "none",
            color: "#fff",
            fontSize: 20,
            width: 44,
            height: 44,
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          &#8594;
        </button>
      </div>
    </div>
  );
};


const generateSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, "") // remove special characters
    .replace(/\s+/g, "-"); // space → dash
};

const RecentInitiative = () => {
  const [lightbox, setLightbox] = useState(null);

  const openLightbox = (e, images, title, index) => {
    e.preventDefault();
    e.stopPropagation();
    setLightbox({ images, title, startIndex: index });
  };

  return (
    <section className="past-events-section recent-initiative">
      {lightbox && (
        <Lightbox
          images={lightbox.images}
          title={lightbox.title}
          startIndex={lightbox.startIndex}
          onClose={() => setLightbox(null)}
        />
      )}

      <div className="past-events-container">
        {/* Header */}
        <div className="past-events-header">
          <p className="past-events-subtitle">RECENT INITIATIVE</p>
          <h1 className="past-events-main-title">AIIFA</h1>
        </div>

        {/* Grid */}
        <div className="past-events-grid past-events-left">
          {initiatives.map((item, index) => (
            <Link
              to={`/${generateSlug(item.title)}`}
              className="past-event-card"
              key={index}
            >
              {/* Image */}
              <div className="past-event-image">
                <Carousel indicators={false} controls interval={2500}>
                  {item.images.map((img, i) => (
                    <Carousel.Item key={i}>
                      <img
                        src={img}
                        alt={item.title}
                        onClick={(e) =>
                          openLightbox(e, item.images, item.title, i)
                        }
                        style={{ cursor: "zoom-in" }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>

              {/* Title */}
              <div className="past-event-title-bar">
                <h3 className="text-white text-sm md:text-base font-semibold leading-[1.9] line-clamp-3 text-center px-3 py-1">
                  {item.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentInitiative;